import axiosInstance from "../services/axiosInstance";

export const logout = async () => {

    try {
        const response = await axiosInstance.post('../auth/logout');

        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
}